export default {
  bindable: {
    type: 'checkbox',
    label: 'Bindable',
    name: 'bindable',
    conditions: [
      {
        condition: '$eq true',
        true: {
          op: 'set',
          value: true
        },
        false: {
          op: 'set',
          value: false
        },
        target: ['font_editable', 'bg_editable']
      },
      {
        condition: '$eq true',
        true: { op: 'show' },
        false: { op: 'hide' },
        target: ['bind_from', 'field', 'data_type']
      }
    ],
    requires: ['bind_from', 'field', 'data_type']
  },
  datasource: {
    type: 'select',
    name: 'bind_from',
    label: 'Data Source',
    visible: false,
    options: [
      { id: 'static', name: 'Static' },
      { id: 'formula', name: 'Formula' },
      { id: 'both', name: 'Both' }
    ]
  },
  fieldname: {
    type: 'text',
    name: 'field',
    label: 'Field Name',
    visible: false,
    unique: true,
    placeholder: 'Enter field name'
  },
  datatype: {
    type: 'select',
    name: 'data_type',
    label: 'Data Type',
    visible: false,
    options: [
      { id: 'string', name: 'string' },
      { id: 'number', name: 'number' }
    ]
  },
  actionable: {
    type: 'checkbox',
    label: 'Action',
    name: 'actionable',
    conditions: [
      {
        condition: '$eq true',
        true: { op: 'show' },
        false: { op: 'hide' },
        target: ['eventname']
      }
    ],
    requires: ['eventname']
  },
  eventName: {
    type: 'text',
    name: 'eventname',
    label: 'Event Name',
    visible: false,
    unique: true,
    placeholder: 'Event name'
  },
  font_property: {
    type: 'checkbox',
    label: 'Font Editable',
    name: 'font_editable',
    conditions: [
      {
        condition: '$eq true',
        true: { op: 'show' },
        false: { op: 'hide' },
        target: ['font_title']
      }
    ],
    requires: ['font_title']
  },
  font_title: {
    type: 'text',
    name: 'font_title',
    label: 'Property Name',
    unique: true,
    visible: false,
    placeholder: 'Font proeprty name'
  },
  bg_property: {
    type: 'checkbox',
    label: 'Background Editable',
    name: 'bg_editable',
    conditions: [
      {
        condition: '$eq true',
        true: { op: 'show' },
        false: { op: 'hide' },
        target: ['bg_title']
      }
    ],
    requires: ['bg_title']
  },
  bg_title: {
    type: 'text',
    name: 'bg_title',
    label: 'Property Name',
    unique: true,
    visible: false,
    placeholder: 'Background pro name'
  }
};
